<template>
  <div class="exam-submit">
    <p class="txt">字号</p>
    <el-row type="flex" justify="space-around" align="middle">
      <el-col :span="6"><span class="set-btn" @click="handleButton('normal')">-</span></el-col>
      <el-col :span="6">{{ $root.setting.fontSize != "bigFont" ? "正常" : "大号" }}</el-col>
      <el-col :span="6"><span class="set-btn" @click="handleButton('bigFont')">+</span></el-col>
    </el-row>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfSettingFontSize",
  ctrlCaption: "设置字体大小",
  data() {
    return {};
  },
  created() {},
  methods: {
    handleButton(type) {
      this.$root.setFontSize(type);
    },
  },
});
</script>
